import { getMinDate } from './dateConstraints';

/**
 * Calculates the next occurrence of a specific holiday date
 * Takes into account the minimum date requirement (2 weeks from now)
 */
export function getNextOccasionDate(occasion: string): string | null {
  const now = new Date();
  const currentYear = now.getFullYear();
  const minDate = new Date(getMinDate());
  
  let nextOccurrence: Date;
  
  switch (occasion) {
    // case 'Christmas':
    //   nextOccurrence = new Date(currentYear, 11, 25); // December 25th
    //   break;
      
    case 'Valentine\'s Day':
      nextOccurrence = new Date(currentYear, 1, 14); // February 14th
      break;
      
    case 'Mother\'s Day':
      // Second Sunday in May
      nextOccurrence = getSecondSundayInMay(currentYear);
      break;
      
    // case 'Hanukkah':
    //   // First night of Hanukkah for current year
    //   nextOccurrence = getHanukkahDate(currentYear);
    //   break;
      
    default:
      return null;
  }
  
  // If the date for this year has already passed or is before min date, get next year's date
  if (nextOccurrence < minDate) {
    switch (occasion) {
      case 'Valentine\'s Day':
        nextOccurrence = new Date(currentYear + 1, 1, 14);
        break;
        
      case 'Mother\'s Day':
        nextOccurrence = getSecondSundayInMay(currentYear + 1);
        break;
    }
  }
  
  // Format as YYYY-MM-DD for HTML date input
  return nextOccurrence.toISOString().split('T')[0];
}

/**
 * Gets the second Sunday in May for a given year (Mother's Day in US)
 */
function getSecondSundayInMay(year: number): Date {
  const may1 = new Date(year, 4, 1); // May 1st
  const firstSunday = new Date(year, 4, 1 + (7 - may1.getDay()) % 7);
  const secondSunday = new Date(firstSunday.getTime() + 7 * 24 * 60 * 60 * 1000);
  return secondSunday;
}

/**
 * Gets the approximate date for first night of Hanukkah
 * This is a simplified calculation - in practice, you'd want to use a proper Hebrew calendar library
 */
function getHanukkahDate(year: number): Date {
  // Hanukkah dates by year (first night)
  const hanukkahDates: { [key: number]: { month: number; day: number } } = {
    2024: { month: 11, day: 25 }, // December 25, 2024
    2025: { month: 11, day: 14 }, // December 14, 2025  
    2026: { month: 11, day: 4 },  // December 4, 2026
    2027: { month: 11, day: 24 }, // December 24, 2027
    2028: { month: 11, day: 12 }, // December 12, 2028
    2029: { month: 11, day: 1 },  // December 1, 2029
    2030: { month: 11, day: 20 }, // December 20, 2030
  };
  
  const hanukkahDate = hanukkahDates[year];
  if (hanukkahDate) {
    return new Date(year, hanukkahDate.month, hanukkahDate.day);
  }
  
  // Fallback to early December if we don't have the exact date
  return new Date(year, 11, 10); // December 10th as approximation
}

/**
 * Checks if an occasion has a known date that can be auto-filled
 */
export function hasKnownDate(occasion: string): boolean {
  return ['Christmas', 'Valentine\'s Day', 'Mother\'s Day', 'Hanukkah'].includes(occasion);
}